<template>
  <div class="container">
    <app-header title="我的订单" :is-back="isBack" @back="back"/>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(item.id)" :class="activeTag==item.id ? 'active':''">{{item.name}}</div>
        </div>
      </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-if="serial == -1">
          <div class="message" v-for="(item,index) in orderList" :key="index">

            <template v-if="item.isBack===0">
              <div class="hint"
                   v-if="item.orderStatus == 2 && item.confirmStatus == 2 && item.isOnlinepay==1">
                {{item.onlineRemark}}
              </div>
              <div class="hint"
                   v-if="item.orderStatus == 2 && item.confirmStatus == 0 && item.isOnlinepay==1">
                等待后台确认付款
              </div>
              <div class="hint"
                   v-if="item.orderStatus == 2 && item.confirmStatus == 0 && item.isOnlinepay==0">
                等待买家付款
              </div>
              <div class="hint" v-if="item.orderStatus == 0">待发货</div>
              <div class="hint" v-if="item.orderStatus == 4">待收货</div>
              <div class="hint" v-if="item.orderStatus == 5">已完成</div>
            </template>
            <template v-if="item.isBack===1">
              <div class="hint" v-if="item.backStatus===0">退款中</div>
              <div class="hint" v-if="item.backStatus===1">退款成功</div>
              <div class="hint" v-if="item.backStatus===2">退款失败:{{item.reMsg}}</div>
            </template>

            <div class="content" v-for="(son,idx) in item.orderItemList" :key="idx" @click="orderDetails(item.id)">
              <img :src="son.shopProduct.image" width="98px" height="110px"/>
              <div class="messages">
                <div class="title">{{son.shopProduct.name}}*{{son.number}}</div>
                <div class="price">￥{{son.price}}</div>
                <div class="mehint">已选:{{son.description}}</div>
              </div>
            </div>
            <div class="allprice" v-if="item.payStatus==0">
              总价￥{{(item.totalPrice + item.couponPrice).toFixed(5)}}，
              优惠￥{{item.couponPrice}}
              需付款{{item.realPrice}}
            </div>
            <div class="allprice" v-if="item.payStatus==1">
              总价￥{{(item.totalPrice + item.couponPrice).toFixed(5)}}，
              优惠￥{{item.couponPrice}}
              已付款{{item.realPrice}}
            </div>
            <div style="display: flex;justify-content: flex-end;">
              <template v-if="item.isBack===0">
                <div
                  v-if="item.isOnlinepay==0 && item.orderStatus==2 || item.isOnlinepay==1 && item.confirmStatus == 2"
                  @click="_saveShopOrder(item.id)" class="pay">付款
                </div>

                <div v-if="item.orderStatus==0" class="pay"
                     @click="remind">提醒发货
                </div>

                <div v-if="item.orderStatus==4 && item.isBack===0" class="pay"
                     style="color: #666666;border: 1px solid #666666;margin-left: 17%"
                     @click="refund(item)">申请退款
                </div>

                <div v-if="item.orderStatus==4" class="pay"
                     style="color: #666666;border: 1px solid #666666;"
                     @click="examine(item)">查看物流
                </div>

                <div class="pay" v-if="item.orderStatus==2"
                     style="color: #666666;border: 1px solid #666666;"
                     @click="_deleteShopOrder(item.id)">删除订单
                </div>
              </template>
              <template v-if="item.isBack===1 && item.backStatus!==2">
                <div class="pay" style="color: #666666;border: 1px solid #666666;"
                     @click="_deleteShopOrder(item.id)">删除订单
                </div>
              </template>
            </div>
          </div>
          <!--<empty  v-if="!orderList.length" title="暂无订单"></empty>-->
        </div>

        <!-- 待支付订单 -->
        <div v-if="serial==2">
          <div class="message" v-for="(item,index) in orderList" :key="index">

            <template v-if="item.isBack===0">
              <div class="hint"
                   v-if="item.orderStatus == 2 && item.confirmStatus == 2 && item.isOnlinepay==1">
                {{item.onlineRemark}}
              </div>
              <div class="hint"
                   v-if="item.orderStatus == 2 && item.confirmStatus == 0 && item.isOnlinepay==1">
                等待后台确认付款
              </div>
              <div class="hint"
                   v-if="item.orderStatus == 2 && item.confirmStatus == 0 && item.isOnlinepay==0">
                等待买家付款
              </div>
            </template>
            <template v-if="item.isBack===1">
              <div class="hint" v-if="item.backStatus===0">退款中</div>
              <div class="hint" v-if="item.backStatus===1">退款成功</div>
              <div class="hint" v-if="item.backStatus===2">退款失败</div>
            </template>

            <div class="content" v-for="(son,idx) in item.orderItemList" :key="idx"
                 @click="orderDetails(item.id)">
              <img :src="son.shopProduct.image" width="98px" height="110px"/>
              <div class="messages">
                <div class="title">{{son.shopProduct.name}}*{{son.number}}</div>
                <div class="price">￥{{son.price}}</div>
                <div class="mehint">已选:{{son.description}}</div>
              </div>
            </div>
            <div class="allprice" v-if="item.payStatus==0">总价￥{{item.totalPrice +
              item.couponPrice}}，优惠￥{{item.couponPrice}} 需付款{{item.realPrice}}
            </div>
            <div class="allprice" v-if="item.payStatus==1">总价￥{{item.totalPrice +
              item.couponPrice}}，优惠￥{{item.couponPrice}} 已付款{{item.realPrice}}
            </div>
            <div style="display: flex;justify-content: flex-end;">
              <div class="pay" @click="_deleteShopOrder(item.id)"
                   v-if="item.backStatus!==2"
                   style="color: #666666;border: 1px solid #666666;">删除订单
              </div>
              <div @click="_saveShopOrder(item.id, item.realPrice)" class="pay"
                   v-if="item.isOnlinepay==0 && item.orderStatus==2 || item.isOnlinepay==1 && item.confirmStatus == 2">
                付款
              </div>
            </div>
          </div>
          <!--<empty  v-if="!orderList.length" title="暂无订单"></empty>-->
          <!--<van-tabbar class="active_tab">-->
          <!--<div class="paybottom">-->
          <!--<div class="allpay">合计：<span class="money">￥{{realPrice}}</span></div>-->
          <!--<div @click="_saveShopOrder(0)" class="payment">立即支付</div>-->
          <!--</div>-->
          <!--</van-tabbar>-->
        </div>

        <!-- 待发货订单 -->
        <div v-if="serial==0">
          <div class="message" v-for="(item,index) in orderList" :key="index">

            <template v-if="item.isBack===0">
              <div class="hint">等待卖家发货</div>
            </template>
            <template v-if="item.isBack===1">
              <div class="hint" v-if="item.backStatus===0">退款中</div>
              <div class="hint" v-if="item.backStatus===1">退款成功</div>
              <div class="hint" v-if="item.backStatus===2">退款失败</div>
            </template>

            <div class="content" v-for="(son,idx) in item.orderItemList" :key="idx"
                 @click="orderDetails(item.id)">
              <img :src="son.shopProduct.image" width="98px" height="110px"/>
              <div class="messages">
                <div class="title">{{son.shopProduct.name}}*{{son.shopProduct.number}}</div>
                <div class="price">￥{{son.shopProduct.price}}</div>
                <div class="mehint">已选:{{son.shopProduct.description}}</div>
              </div>
            </div>
            <div class="allprice" v-if="item.payStatus==0">总价￥{{item.totalPrice +
              item.couponPrice}}，优惠￥{{item.couponPrice}} 需付款{{item.realPrice}}
            </div>
            <div class="allprice" v-if="item.payStatus==1">总价￥{{item.totalPrice +
              item.couponPrice}}，优惠￥{{item.couponPrice}} 已付款{{item.realPrice}}
            </div>
            <div style="display: flex;justify-content: flex-end;">

              <template v-if="item.isBack===0">
                <div class="pay" @click="remind">提醒发货</div>
                <div class="pay" style="color: #666666;border: 1px solid #666666;margin-left: 17%"
                     @click="refund(item)">申请退款
                </div>
              </template>
              <template v-if="item.isBack===1">

              </template>

            </div>
          </div>
          <!--<empty  v-if="!orderList.length" title="暂无订单"></empty>-->
        </div>

        <!-- 待收货订单 -->
        <div v-if="serial==4">
          <div class="message" v-for="(item,index) in orderList" :key="index">

            <template v-if="item.isBack===0">
              <div class="hint">待收货</div>
            </template>
            <template v-if="item.isBack===1">
              <div class="hint" v-if="item.backStatus===0">退款中</div>
              <div class="hint" v-if="item.backStatus===1">退款成功</div>
              <div class="hint" v-if="item.backStatus===2">退款失败</div>
            </template>

            <div class="content" v-for="(son,idx) in item.orderItemList" :key="idx"
                 @click="orderDetails(item.id)">
              <img :src="son.shopProduct.image" width="98px" height="110px"/>
              <div class="messages">
                <div class="title">{{son.shopProduct.name}}*{{son.shopProduct.number}}</div>
                <div class="price">￥{{son.shopProduct.price}}</div>
                <div class="mehint">已选:{{son.shopProduct.description}}</div>
              </div>
            </div>
            <div class="allprice" v-if="item.payStatus==0">总价￥{{item.totalPrice +
              item.couponPrice}}，优惠￥{{item.couponPrice}} 需付款{{item.realPrice}}
            </div>
            <div class="allprice" v-if="item.payStatus==1">总价￥{{item.totalPrice +
              item.couponPrice}}，优惠￥{{item.couponPrice}} 已付款{{item.realPrice}}
            </div>
            <div style="display: flex;justify-content: flex-end;">

              <template v-if="item.isBack===0">
                <div class="pay" style="color: #666666;border: 1px solid #666666;margin-left: 17%"
                     @click="refund(item)">申请退款
                </div>
                <div class="pay" style="color: #666666;border: 1px solid #666666;" @click="examine(item)">
                  查看物流
                </div>
                <div class="pay" style="color:rgba(254,0,59,1);border:1px solid rgba(254,0,59,1);"
                     @click="confirmReceipt(item.id)">确认收货
                </div>
              </template>
              <template v-if="item.isBack===1">

              </template>
            </div>
          </div>
          <!--<empty  v-if="!orderList.length" title="暂无订单"></empty>-->
        </div>
      </van-list>
    </van-pull-refresh>

  </div>
</template>

<script>
  import {
    getOrderAndProduct,
    getOrderAndProductPage,
    deleteShopOrder,
    wxPayServiceFee,
    queryorder,
    confirmReceipt,
    delShopOrder
  } from '@/api/order'

  export default {
    name: 'Order',
    data() {
      return {


        loading: false,
        finished: false,
        refreshing: false,
        list: [],
        orderList: [],
        total: 0,
        pages: 1,
        listQuery: {
          page: 1,
          limit: 10,
          query: {}
        },

        isBack: false,
        serial: -1,
        activeTag: -1,
        tabList: [{name: '全部', id: -1}, {name: '待支付', id: 2}, {name: '待发货', id: 0}, {name: '待收货', id: 4}],

        realPrice: 0
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (from.name == 'orderDetails' || from.name == 'logistics' || from.name == 'logisticsRenGon' || from.name == 'refund') {
          if (from.params.orderStatus || from.params.orderStatus === 0) {
            vm.orderStatus = from.params.orderStatus
            vm.serial = from.params.orderStatus
            vm.activeTag = from.params.orderStatus
          }
        }

      })
    },
    beforeRouteLeave (to, from, next) {
      localStorage.setItem("scrollOrder", document.querySelector(".container").scrollTop)
      next()
    },
    activated:function() {
      this.$nextTick(() => {
        document.querySelector(".container").scrollTop = localStorage.getItem("scrollOrder")
        localStorage.setItem("scrollOrder", 0)
      })

    },
    created() {
      var orderStatus = this.$route.query.orderStatus
      if (orderStatus != undefined && orderStatus != null) {
        this.serial = orderStatus
        this.activeTag = orderStatus
      }
      // this.onLoad();
      // this.getList()
    },
    methods: {
      onLoad() {
        var user = localStorage.getItem('userInfo')
        if (!user) {
          this.$router.push({
            path: '/loign'
          })
          return;
        }
        user = JSON.parse(user)

        let params = {
          uid: user.id,
          orderStatus: this.serial,
          isDel: 0
        }
        this.listQuery.query = params;
        getOrderAndProductPage(this.listQuery).then(res => {
          if (res.success) {

            if (this.refreshing) {
              this.orderList = [];
              this.refreshing = false;
            }
            this.pages = res.data.pages
            this.total = res.data.total
            if (res.data.records.length==0) {
              this.finished = true;
            }else{
              res.data.records.forEach((item) => {
                this.orderList.push(item);
              });
              this.loading = false
              this.listQuery.page ++;
            }

          }
        })

      },
      onRefresh() {
        this.total = 0;
        this.orderList = [];
        this.listQuery.page = 1;
        this.finished = false;
        this.loading = true;
        this.onLoad();
      },
      back() {
        this.$router.push({path: '/mine'})
      },
      onNavigate(id) {
        this.$router.push({
          path: '/product/detail',
          query: {id: id}
        })
      },
      // delete order info
      _deleteShopOrder(id) {
        this.$dialog.confirm({
          title: '是否确认删除？'
        }).then(() => {
          const params = {
            id: id
          }
          delShopOrder(params).then((res) => {
            if (res.success) {
              this.$toast.success('删除成功')
              this.getList();
              // this.getList()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }).catch(() => {

        });
      },
      _saveShopOrder(id, realPrice) {
        const cpoids = []
        if (id) {
          cpoids.push(id)
        } else {
          this.orderList.forEach((item) => {
            cpoids.push(item.id)
          })
        }
        var openid = localStorage.getItem('openid')

        var user = localStorage.getItem("userInfo");
        if (user != null) {
          user = JSON.parse(user)
          if (openid == null) {
            openid = user.openid
          }
        }
        const params = {
          cpoids: cpoids.join(','),
          realPrice: realPrice,
          openid: openid,
          id: id,
          uid: user.id
        }
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          params.isWeb = 0;
        } else {
          params.isWeb = 1;
        }
        console.log(params)
        wxPayServiceFee(params).then((res) => {
          if (res.success) {
            const data = res.payMap
            if(data.payUrl) {
              window.location = data.payUrl
            } else {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                  appId: data.appId, // 公众号名称(商户appid)
                  timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
                  nonceStr: data.nonceStr, // 随机串
                  package: data.package,
                  signType: data.signType, // 微信签名方式：
                  paySign: data.paySign // 微信签名
                }, (r) => {
                  if (r.err_msg == 'get_brand_wcpay_request:ok') {
                    this.$toast.success('支付成功')
                    this.getList();
                    // this.getList()
                    return;
                  }
                })
            }
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      getList() {
        var user = localStorage.getItem('userInfo')
        if (!user) {
          this.$router.push({
            path: '/loign'
          })
          return;
        }
        user = JSON.parse(user)

        let params = {
          uid: user.id,
          orderStatus: this.serial,
          isDel: 0
        }
        this.listQuery.page = 1;
        this.listQuery.query = params;
        getOrderAndProductPage(this.listQuery).then(res => {
          if (res.success) {

            this.orderList = [];

            if (this.refreshing) {
              this.refreshing = false;
            }
            this.pages = res.data.pages
            this.total = res.data.total
            if (res.data.records==0) {
              this.finished = true;
            }else{
              res.data.records.forEach((item) => {
                this.orderList.push(item);
              });
              this.loading = false
              this.listQuery.page ++;
            }

          }
        })
      },
      handleTag(index) {
        this.activeTag = index
        this.serial = index
        this.total = 0;
        this.orderList = [];
        this.listQuery.page = 1;
        this.finished = false;
        this.loading = true;
        this.onLoad();
        // this.getList()
      },
      remind (){
        this.$toast.success('提醒成功')
      },
      confirmReceipt(orderId) {
        this.$dialog.confirm({
          title: '是否确认收货？'
        }).then(() => {
          confirmReceipt({id: orderId}).then((res) => {
            if (res.success) {
              this.$toast.success('收货成功')
              this.getList()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }).catch(() => {

        });
      },
      examine(row) {
        if (row.shippingType == 0) {
          this.$router.push({
            path: '/order/logistics',
            query: {
              orderId: row.id,
              orderStatus: this.serial
            }
          })
        }
        if (row.shippingType == 1) {
          this.$router.push({
            path: '/order/logisticsRenGon',
            query: {
              orderId: row.id,
              orderStatus: this.serial
            }
          })
        }

      },
      refund(row) {
        this.$router.push({
          path: '/refund',
          query: {
            orderId: row.id,
            orderStatus: this.serial,
            total: row.totalPrice
          }
        })
      },
      orderDetails(orderId) {
        this.$router.push({
          path: '/order/details',
          query: {
            orderId: orderId,
            orderStatus: this.serial
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .container {
    .tabs {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 44px;
      padding: 0 12px;
      .tab {
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        .item {
          font-size: 14px;
          font-weight: 500;
          height: 22px;
          font-family: PingFang SC;
          line-height: 22px;
          color: rgba(51, 51, 51, 1);
          margin-right: 14px;
          .active {
            font-size: 16px;
            font-weight: bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .message {
      border-top: 2px solid #f3f3f3;
      padding: 10px;
      /*margin-bottom: 40px;*/
      .hint {
        margin-top: 19px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: rgba(254, 0, 59, 1);
        opacity: 1;
        text-align: right;
        margin-right: 12px;
      }
      .content {
        display: flex;
        flex-direction: row;
        margin-bottom: 10px;
        .messages {
          width: 100%;
          margin-left: 17px;
          .title {
            /*height:47px;*/
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 18px;
            color: rgba(51, 51, 51, 1);
            opacity: 1;
            overflow: hidden;
            word-wrap: break-word;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            flex: 1;
          }
          .price {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 18px;
            color: rgba(51, 51, 51, 1);
            margin: 10px 0;
          }
          .mehint {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 17px;
            color: rgba(136, 137, 136, 1);
            background: rgba(243, 243, 243, 1);
            border-radius: 1px;
            opacity: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 1px 3px;
          }
        }
      }
      .allprice {
        height: 20px;
        font-size: 12px;
        text-align: right;
        margin-right: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 17px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
      .pay {
        margin-top: 30px;
        // margin-left: auto;
        margin-right: 12px;
        width: 84px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(254, 0, 59, 1);
        opacity: 1;
        text-align: center;
        border-radius: 14px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 28px;
        color: rgba(254, 0, 59, 1);
      }
    }
    .paybottom {
      display: flex;
      width: 100%;
      justify-content: space-between;
      .allpay {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 50px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        margin-left: 60px;
        .money {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 21px;
          color: rgba(254, 0, 59, 1);
          opacity: 1;
        }
      }
      .payment {
        width: 155px;
        height: 40px;
        background: linear-gradient(0deg, rgba(244, 4, 66, 1) 0%, rgba(226, 23, 75, 0.73) 100%);
        opacity: 1;
        border-radius: 4px;
        margin: 6px;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 40px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/order/index.vue